module.exports = __webpack_public_path__ + "img/feat-gallery-1.4f3ca942.jpg";